import React, { useState } from 'react';
import { Button } from 'reactstrap';
import DetailModal from './DetailModal';

const COLUMNS = [
  {
    key: 'image',
    label: '',
    format: (url, row) =>
      url ? (
        <img src={url} alt={row.name} style={{ width: 32, height: 32, objectFit: 'cover', borderRadius: 6 }} />
      ) : (
        <div style={{ width: 32, height: 32, borderRadius: 6, background: '#f1f5f9' }} />
      ),
  },
  { key: 'name', label: 'Produto' },
  { key: 'quantity', label: 'Unidades', align: 'right' },
];

// Mostra sempre os 5 primeiros; "Detalhar" abre modal com a lista completa
// (o backend já manda ordenado do que mais vende pro que menos vende).
// A foto pequena ajuda a alinhar visualmente item a item na lista.
const TopSellingList = ({ items }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const all = items || [];
  const top5 = all.slice(0, 5);

  if (all.length === 0) {
    return <p className="text-muted mb-0">Sem vendas nesse período.</p>;
  }

  return (
    <div>
      <ul className="list-unstyled mb-3">
        {top5.map((item) => (
          <li key={item.productId} className="d-flex align-items-center mb-2">
            {item.image ? (
              <img
                src={item.image}
                alt={item.name}
                style={{ width: 32, height: 32, objectFit: 'cover', borderRadius: 6, marginRight: 10, flexShrink: 0 }}
              />
            ) : (
              <div style={{ width: 32, height: 32, borderRadius: 6, background: '#f1f5f9', marginRight: 10, flexShrink: 0 }} />
            )}
            <span className="text-truncate mr-2" style={{ fontSize: 14, flex: 1 }}>{item.name}</span>
            <span className="font-weight-bold" style={{ fontSize: 14 }}>{item.quantity} unidades</span>
          </li>
        ))}
      </ul>
      {all.length > 5 && (
        <Button color="link" size="sm" className="p-0" onClick={() => setModalOpen(true)}>
          Detalhar
        </Button>
      )}
      <DetailModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        title="Itens mais vendidos"
        columns={COLUMNS}
        rows={all}
      />
    </div>
  );
};

export default TopSellingList;
